import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomTooltip from '../CustomTooltip';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 * @Description Round button to add without background
 * @param String id: Button identifier (required).
 * @param String title: Title of button (required).
 * @param event onClick: Click event on the button (optional).
 * @param String url: Navigation URL (optional).
 * @param {JSX.Element} Icon: Icon component (required).
 * @param String className: Style class for the button or default style class declared (optional).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param String iconProps: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @returns {JSX.Element}
 */
const ButtonIconAdd = (props) => {
    const {
        id = 'btn_bia_icon_add ',
        onClick = null,
        url = '',
        Icon,
        className = 'btn-outlined-secondary-500-600',
        disabled = false,
        iconProps = '',
        tooltipPlacement = 'bottom',
        renderTooltipContent = "",
    } = props;
    const navigate = useNavigate();

    return (
        <>
            {renderTooltipContent !== "" ? (
                <CustomTooltip text={renderTooltipContent} placement={tooltipPlacement}>
                    <button
                        id={id}
                        className={`btn-outlined-secondary-500-600 ${className}`}
                        disabled={disabled}
                        onClick={(e) => {
                            if (onClick !== null) onClick(e);
                            if (url != '') navigate(url);
                        }}
                    >
                        {Icon && <Icon className={`btn-icon-svg-30px ${iconProps}`} />}
                    </button>
                </CustomTooltip>
            ) : (
                <button
                    id={id}
                    className={`btn-outlined-secondary-500-600 ${className}`}
                    disabled={disabled}
                    onClick={(e) => {
                        if (onClick !== null) onClick(e);
                        if (url != '') navigate(url);
                    }}
                >
                    {Icon && <Icon className={`btn-icon-svg-30px ${iconProps}`} />}
                </button>
            )}
        </>
    );
};

export default ButtonIconAdd;
